import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';
import { RewardType } from '~/shared';
import shadow from '../../assets/images/shop_open_case/open_case_item_shadow.png';

const StyledContainer = styled.div`
	position: relative;
	height: 220px;
	background: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
	overflow: hidden;
`;

const StyledShadow = styled.div`
	position: absolute;
	bottom: -250px;
	left: 50%;
	transform: translateX(-50%);
	width: 500px;
	height: 500px;
	mask-image: url(${shadow});
	mask-size: 500px 500px;
	mask-repeat: no-repeat;
	mask-position: center;
	-webkit-mask-image: url(${shadow});
	-webkit-mask-size: 500px 500px;
	-webkit-mask-repeat: no-repeat;
	-webkit-mask-position: center;
	pointer-events: none;
`;

const StyledTitleContainer = styled.div<{ $color: string }>`
	position: absolute;
	top: 20px;
	left: 20px;
	display: flex;
	align-items: center;
	gap: 6px;

	.dot {
		width: 10px;
		height: 10px;
		background: ${(props) => props.$color};
		border-radius: 10px;
	}

	${Text} {
		font-weight: 500;
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledImageContainer = styled.div<{ $type: RewardType }>`
	position: absolute;
	bottom: 20px;
	left: 50%;
	transform: translateX(-50%);

	${(props) =>
		props.$type === RewardType.VEHICLE &&
		css`
			bottom: 40px;
		`}

	${(props) =>
		(props.$type === RewardType.ITEM || props.$type === RewardType.MONEY) &&
		css`
			bottom: 30px;
		`}

		${(props) =>
		props.$type === RewardType.EXP &&
		css`
			bottom: 83px;
		`}

	${(props) =>
		props.$type === RewardType.LOOTBOX &&
		css`
			bottom: -20px;
		`}


	img {
		user-select: none;
		pointer-events: none;
	}
`;

const StyledExpContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	${Text} {
		font-weight: 700;
		font-size: 30px;
		color: #ffffff;
	}
`;

const StyledButton = styled.div`
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
	display: flex;
	justify-content: center;
	align-items: center;
	width: 30px;
	height: 30px;
	background: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 30px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition: filter 0.3s ease;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledContentWrapper = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	transition: opacity 0.3s ease;

	&.fade-enter {
		opacity: 0;
	}

	&.fade-enter-active,
	&.fade-enter-done,
	&.fade-exit {
		opacity: 1;
	}

	&.fade-exit-active {
		opacity: 0;
	}
`;

export {
	StyledButton,
	StyledContainer,
	StyledContentWrapper,
	StyledExpContainer,
	StyledImageContainer,
	StyledShadow,
	StyledTitleContainer,
};
